module.exports = __webpack_public_path__ + "img/02d@2x.80a5d865.svg";